import React, { useEffect, useState } from 'react';
import Messages from '../components/Messages.js';
import { getEmails, getCustomFilterEmails } from '../helper/apiHelper.js';
import { useLoading } from '../context/LoadingContext';
import { useDispatch, useSelector } from "react-redux";
import { fomatedEmail } from '../helper/commonHelper.js';

function Important() {
    const [user, setUser] = useState({
        name: '',
        wallet: {
            wallet: {
                address: '',
                privateKey: ''
            }
        }
    });
    const [messages, setMessages] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const pageType = 'important';
    const dispatch = useDispatch();
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const search = useSelector((state) => state.searchMessage);
    const triggerPaninate = useSelector((state) => state.triggerPaninate);
    const triggerFilter = useSelector((state) => state.trigger);
    const filterObject = useSelector((state) => state.filterObject);

    useEffect(() => {
        const userdata = JSON.parse(localStorage.getItem('user'));
        setUser(userdata);
        getEmailData(userdata.wallet.username);
        dispatch({ type: "FILTER_OBJECT", payload: {}, value: !triggerFilter });
    }, [])

    useEffect(() => {
        const getData = async () => {
            await getEmailData(user.wallet.username);
        }
        getData();
    }, [refreshMessage])

    const getEmailData = async (email, searchTerm = '') => {
        if (!email) return;
        showLoader();
        const data = await getEmails(email, pageType, searchTerm);
        const formattedResult = await fomatedEmail(data.res, pageType);
        setMessages(formattedResult);
        hideLoader();
    }

    const reRender = async () => {
        dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage })
    }

    useEffect(() => {
        getEmailData(user.wallet.username, search);
    }, [search])

    const getPaginatedData = async (length) => {
        const data = await getEmails(user.wallet.username, pageType, null, (length + 1));
        const fData = await fomatedEmail(data.res, pageType);
        setMessages([...messages, ...fData]);
    }

    useEffect(() => {
        const noGroupCount = messages.filter((item) => !item.groupKey).length;
        const groupCount = messages.filter((item) => item.groupKey).reduce((total, group) => total + group.data.length, 0);
        const total = noGroupCount + groupCount;
        if (total > 49) {
            getPaginatedData(total);
        }
    }, [triggerPaninate])

    const getFilterEmail = async () => {
        const data = await getCustomFilterEmails(pageType, JSON.stringify(filterObject));
        const fData = await fomatedEmail(data.res, pageType);
        setMessages(fData);
    }

    useEffect(() => {
        getFilterEmail();
    }, [triggerFilter])

    return (
        <>
            <Messages messages={messages} reRender={reRender} pageType={pageType} />
        </>
    );
}

export default Important;
